import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OrderDepthResponseInterface, DepthFilter, DepthFilterSymbolID } from '../../../../../app.interfaces';
import { retry } from 'rxjs/operators';
import { applicationUrls } from 'sharedweb/helpers/urls';

@Injectable({
    providedIn: 'root'
})
export class OrderDepthService {

    constructor(private _httpClient: HttpClient) { }
}
